import React, { Component } from 'react';
import { Col } from 'react-flexbox-grid';
import classnames from 'classnames';
import styles from './TimelineCircle.styl';

class TimelineCircle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };

    this.toggleHover = this.toggleHover.bind(this);
  }

  toggleHoverOn = () => {
    this.setState({
      hover: true
    })
  }

  toggleHoverOff = () => {
    this.setState({
      hover: false
    })
  }

  toggleHover = () => {
    this.setState({
      hover: !this.state.hover
    });
  };

  render() {
    let circle = this.props.circle;
    let gradientLine =
      circle.size === 'big' ? (
        <div
          className={classnames(styles.gradientLine, styles[circle.position], {
            [styles.hover]: this.state.hover
          })}
        />
      ) : (
        ''
      );
    return (
      <Col xs className={styles.timelineItem}>
        <div
          className={
            circle.size === 'big' ? (
              classnames(styles.verticalLine, styles[circle.position])
            ) : (
              ''
            )
          }
          style={{ backgroundColor: circle.color }}
        />
        {circle.info ? (
          <div onMouseLeave={this.toggleHoverOff} className={classnames(styles[circle.infoSize])}>
            <div
              className={classnames(styles.year, styles[circle.position], {
                [styles.hover]: this.state.hover
              })}
            >
              <p onMouseEnter={this.toggleHoverOn}>{circle.year}</p>
            </div>
            {gradientLine}
            <div
            onMouseLeave={this.toggleHoverOff}
              className={classnames(styles.info, styles[circle.position], {
                [styles.hover]: this.state.hover
              })}
            >
              <p>{circle.info}</p>
            </div>
          </div>
        ) : (
          ''
        )}
        <div
          className={classnames(styles.circle, styles[circle.size])}
          style={{
            borderColor: circle.color,
            backgroundColor:
              this.state.hover && circle.size === 'big' ? circle.color : '#fff',
            cursor:
              this.state.hover && circle.size === 'big' ? 'pointer' : 'default'
          }}
          onMouseEnter={this.toggleHover}
          onMouseLeave={this.toggleHover}
        />
      </Col>
    );
  }
}

export default TimelineCircle;



// WEBPACK FOOTER //
// ./src/components/timeline/TimelineCircle.js